<template>
  <div>
    <template>
      <v-card class="mx-auto" justifiy="center" align="center">
        <v-app-bar class="transparent" light flat>
          <v-toolbar-title>
            <!--  <v-btn icon @click.stop="fusionner(), $router.go(-1)">
              <v-icon>mdi-arrow-left-circle-outline</v-icon>
            </v-btn> -->
            <v-btn icon @click.stop="$router.go(-1)">
              <v-icon>mdi-arrow-left-circle-outline</v-icon>
            </v-btn>
            {{ $route.query.ll_formation_groupe }}
          </v-toolbar-title>
        </v-app-bar>

        <v-card flat>
          <v-card-text v-if="detailsFormation">
            <v-layout row justify-center>
              <v-dialog v-model="editDialog" max-width="350">
                <v-card>
                  <v-card-title>
                    <span class="headline">Editer Sexe</span>
                  </v-card-title>
                  <v-card-text>
                    <v-form ref="form">
                      <v-container fluid>
                        <v-row no-gutters="">
                          <v-col cols="12">
                            <v-radio-group v-model="editedItem.sexe" row>
                              <v-radio
                                label="Masculin"
                                :value="parseInt(1)"
                              ></v-radio>
                              <v-radio
                                label="Féminin"
                                :value="parseInt(0)"
                              ></v-radio>
                            </v-radio-group>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-form>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn rounded color="info" @click.native="closeDialog()"
                      >Annuler</v-btn
                    >
                    <v-btn
                      rounded
                      color="primary"
                      @click.native="updateMembre()"
                      >Mettre à jour</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-layout>

            <div>
              Formation dans le cadre de l'activité:
              <span>
                {{ detailsFormation.ll_parcours }}
              </span>
            </div>

            <div>Projet : {{ detailsFormation.ll_programme }}</div>
            <div>Groupe : {{ detailsFormation.nom_groupe }}</div>
            <div>Animateur : {{ detailsFormation.nom_responsable }}</div>
            <div>
              Date :
              {{
                $moment(detailsFormation.date_formation_groupe).format(
                  "Do MMMM YYYY"
                )
              }}
            </div>
            <div>
              Présents : {{ NombreMembresPresents.length }}/{{
                MembresDuGroupeActifs.length
              }}
            </div>

            <v-simple-table style="width: 500px;">
              <thead>
                <tr>
                  <th scope="col">&nbsp;</th>
                  <th scope="col">Données Totales</th>
                  <th scope="col">Données Détails</th>
                  <!-- <th scope="col">Etat</th> -->
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Femmes</td>
                  <td>{{ detailsFormation.nbFemme }}</td>
                  <td>{{ listeMembresPresents.nbFemme }}</td>
                  <!--     <td>
                    <div
                      v-if="
                        detailsFormation.nbFemme ===
                        listeMembresPresents.nbFemme
                      "
                    >
                      <v-icon color="green darken-2">
                        mdi-check
                      </v-icon>
                    </div>
                    <div v-else>
                      <v-icon color="error">
                        mdi-alert
                      </v-icon>
                    </div>
                  </td> -->
                </tr>
                <tr>
                  <td>Hommes</td>
                  <td>{{ detailsFormation.nbHomme }}</td>
                  <td>{{ listeMembresPresents.nbHomme }}</td>
                  <!--    <td>
                    <div
                      v-if="
                        detailsFormation.nbHomme ===
                        listeMembresPresents.nbHomme
                      "
                    >
                      <v-icon color="green darken-2">
                        mdi-check
                      </v-icon>
                    </div>
                    <div v-else>
                      <v-icon color="error">
                        mdi-alert
                      </v-icon>
                    </div>
                  </td> -->
                </tr>
                <tr>
                  <td>Total</td>
                  <td>
                    {{
                      parseInt(detailsFormation.nbFemme) +
                      parseInt(detailsFormation.nbHomme)
                    }}/{{ MembresDuGroupeActifs.length }}
                  </td>
                  <td>
                    {{ NombreMembresPresents.length }}/{{
                      MembresDuGroupeActifs.length
                    }}
                  </td>
                  <td></td>
                </tr>
              </tbody>
            </v-simple-table>
            <div>Date de Fusion: {{ detailsFormation.dateFusion }}</div>
            <div>Opérateur: {{ detailsFormation.operateur }}</div>
            <!--   <v-btn
              class="warning my-4"
              v-if="user.role != 'superviseur'"
              rounded
              @click="fusionner()"
              >Fusionner <v-icon right dark>mdi-reload</v-icon></v-btn
            > -->
          </v-card-text>
          <!--  <v-card-text v-if="user.role != 'superviseur'  || user.isPaysanRelais"> -->
          <v-card-text v-if="user.role != 'superviseur'">
            <div class="flex-table">
              <div>Nom</div>
              <div>Age</div>
              <div>Sexe</div>
              <div>Actions</div>
            </div>

            <div
              class="flex-table"
              v-for="(item, index) in membresPresents"
              :key="index"
              v-bind:class="{
                'grey lighten-1 ': item.actif_dans_groupe === 0,
              }"
            >
              <div>{{ item.nom }}</div>
              <div>
                {{ calculate_age(new Date(item.annee_naissance, 1, 1)) }} ans
              </div>
              <div>{{ getSexe(item.sexe) }}</div>

              <div v-if="item.sexe !== 1 || item.sexe !== 0">
                <v-checkbox
                  v-if="item.present"
                  v-model="item.present"
                  @change="deletePresenceFormationDeGroupe(item)"
                ></v-checkbox>
                <v-checkbox
                  v-else
                  v-model="item.present"
                  @change="createPresenceFormationDeGroupe(item)"
                ></v-checkbox>
              </div>
              <div v-else>
                <v-btn
                  color="grey lighten-2 mr-4"
                  fab
                  class="elevation-0"
                  @click="showEditDialog(item)"
                >
                  <v-icon>mdi-account-edit-outline</v-icon>
                </v-btn>
              </div>
            </div>
          </v-card-text>
          <v-card-actions v-if="user.role != 'superviseur'">
            <v-spacer></v-spacer>
            <v-btn
              rounded
              color="success"
              @click.stop="nbDetail(), $router.go(-1)"
              >Sauvegarder</v-btn
            >
          </v-card-actions>
        </v-card>

        <v-card-actions>
          <Navigation :elements="SuperviseurNavigation" />
        </v-card-actions>
      </v-card>
    </template>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  created() {
    let self = this;
    this.GetMembresDuGroupe(self.$route.query.id_groupe);
    this.getDetailsFormationDeGroupe(this.$route.params.id);
    this.GetSuperviseurPresencesFormationsDeGroupe({
      idAnimateur: this.$route.query.idAnimateur,
      idFormation: this.$route.params.id,
    });

    /**** */
    var lastChecked = self.$moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
    var formationRef = this.$firebase
      .firestore()
      .collection("formationsDeGroupe")
      .doc(this.$route.params.id);
    formationRef
      .update({
        lastChecked: lastChecked,
      })
      .then(() => {
        console.log("Document successfully updated!");
      })
      .catch((error) => {
        // The document probably doesn't exist.
        console.error("Error updating document: ", error);
      });
    /*** */
  },
  mounted() {},
  data() {
    return {
      detailsFormation: null,
      checkbox: [],
      editDialog: false,
      editedItem: {},
    };
  },
  components: {
    Navigation: require("@/components/Navigation.vue").default,
  },
  methods: {
    showEditDialog(item) {
      this.editDialog = true;
      this.editedItem = item;
    },
    closeDialog() {
      this.editDialog = false;
    },

    updateMembre() {
      const self = this;
      var luser = {
        sexe: this.editedItem.sexe,
      };

      console.log(luser);

      var ref = this.$firebase
        .firestore()
        .collection("membres")
        .doc(this.editedItem.id);
      ref
        .set(luser, { merge: true })
        .then(function () {
          console.log("membre successfully updated!");
          var objet = { userId: self.editedItem.id, data: luser };
          self.UpdateMembreDansAutresCollections(objet);
          self.code_menage_selected = false;
          self.editDialog = false;
          self.GetMembresDuGroupe(self.editedItem.id_groupe);
        })
        .catch(function (error) {
          console.error("Error updating document: ", error);
          self.GetMembresDuGroupe(self.editedItem.id_groupe);
          self.GetMembresDuGroupeInactifs(self.editedItem.id_groupe);

          self.editDialog = false;
        });
    },

    fusionner() {
      let self = this;

      this.$firebase
        .firestore()
        .collection("formationsDeGroupe")
        .doc(self.detailsFormation.id)
        .set(
          {
            nbHomme: self.listeMembresPresents.nbHomme,
            nbFemme: self.listeMembresPresents.nbFemme,
            fusion: true,
            dateFusion: self.$moment(Date.now()).format("YYYY-MM-DD HH:mm:ss"),
            operateur: self.user.displayName,
          },
          { merge: true }
        )
        .then(function () {
          console.log("Document successfully written!");
          self.getDetailsFormationDeGroupe(self.detailsFormation.id);

          /////
          var objet = {
            userId: self.detailsFormation.responsable,
            project: { id: self.detailsFormation.programmes_id_programme },
            start: self
              .$moment(Date.now())
              .subtract(3, "months")
              .format("YYYY-MM-DD HH:mm:ss"),
            end: self
              .$moment(Date.now())
              .add(3, "days")
              .format("YYYY-MM-DD HH:mm:ss"),
          };

          self.GetFormationsDuSuperviseur(objet);
          /////
        })
        .catch(function (error) {
          console.error("Error writing document: ", error);
        });
    },
    nbDetail() {
      let self = this;

      this.$firebase
        .firestore()
        .collection("formationsDeGroupe")
        .doc(self.detailsFormation.id)
        .set(
          {
            nbDetailHomme: self.listeMembresPresents.nbHomme,
            nbDetailFemme: self.listeMembresPresents.nbFemme,
            fusion: true,
            dateFusion: self.$moment(Date.now()).format("YYYY-MM-DD HH:mm:ss"),
            operateur: self.user.displayName,
          },
          { merge: true }
        )
        .then(function () {
          console.log("Document successfully written!");
          self.getDetailsFormationDeGroupe(self.detailsFormation.id);

          /////
          var objet = {
            userId: self.detailsFormation.responsable,
            project: { id: self.detailsFormation.programmes_id_programme },
            start: self
              .$moment(Date.now())
              .subtract(3, "months")
              .format("YYYY-MM-DD HH:mm:ss"),
            end: self
              .$moment(Date.now())
              .add(3, "days")
              .format("YYYY-MM-DD HH:mm:ss"),
          };

          self.GetFormationsDuSuperviseur(objet);
          /////
        })
        .catch(function (error) {
          console.error("Error writing document: ", error);
        });
    },
    printPresence() {
      var objectToSend = {
        detailsFormation: this.detailsFormation,
        membres: this.MembresDuGroupeActifs,
      };
      this.$router.push({
        name: "groupes-presenceFormationGroupe-print",
        params: objectToSend,
      });
    },
    getDetailsFormationDeGroupe(idFormation) {
      const self = this;
      console.log("idFormation de Groupe:", idFormation);
      var docRef = this.$firebase
        .firestore()
        .collection("formationsDeGroupe")
        .doc(idFormation);
      docRef
        .get()
        .then(function (doc) {
          if (doc.exists) {
            //console.log("Document data:", doc.data());
            self.detailsFormation = doc.data();
          } else {
            // doc.data() will be undefined in this case
            console.log("No such document!");
          }
        })
        .catch(function (error) {
          console.log("Error getting document:", error);
        });
    },
    createPresenceFormationDeGroupe(membre) {
      let self = this;
      let uuid = "-------------000000000000000aaaa-" + this.$uuid.v4();
      const newItem = {
        nom_groupe: membre.nom_groupe,
        nom_responsable: membre.nom_responsable,
        ll_fokontany: membre.ll_fokontany,
        ll_district: membre.ll_district,
        nom: membre.nom,
        //code_menage: membre.code_menage,
        id_district: membre.id_district,
        groupes_id_groupe: membre.id_groupe,
        ll_region: membre.ll_region,
        sexe: membre.sexe,
        id_region: membre.id_region,
        id_responsable: membre.id_responsable,
        ll_commune: membre.ll_commune,
        annee_naissance: membre.annee_naissance,
        code_fokontany: membre.code_fokontany,
        membres_id_membre: membre.id,
        id_commune: membre.id_commune,
        village: membre.village,
        //ll_province: this.detailsFormation.ll_province,
        //id_province: this.detailsFormation.id_province,
        themes_id_theme: this.detailsFormation.themes_id_theme,
        ll_programme: this.detailsFormation.ll_programme,
        parcours_id_parcours: this.detailsFormation.parcours_id_parcours,
        ll_theme: this.detailsFormation.ll_theme,
        programmes_id_programme: this.detailsFormation.programmes_id_programme,
        ll_parcours: this.detailsFormation.ll_parcours,
        description_parcours: this.detailsFormation.description_parcours,
        ll_formation_groupe: this.detailsFormation.ll_formation_groupe,
        formations_groupes_id_formation_groupe: this.$route.params.id,
        abbr_parcours: this.detailsFormation.abbr_parcours,
        date_formation_groupe: this.detailsFormation.date_formation_groupe,
        // bailleurs_id_bailleur: this.detailsFormation.bailleurs_id_bailleur,
        //ll_bailleur: this.detailsFormation.ll_bailleur,
        //objectifs: this.detailsFormation.objectifs,
        //abbr_bailleur: this.detailsFormation.abbr_bailleur,
      };
      console.log(this.detailsFormation);
      this.$firebase
        .firestore()
        .collection("presencesFormationsGroupes")
        .doc(uuid)
        .set(newItem, { merge: true });
      console.log("Présence Formation de groupe créé id: " + uuid);
      //vuex insert presencesFormationsGroupes
      this.addOneItem(newItem);
      this.GetMembresDuGroupe(self.$route.query.id_groupe);
      this.GetSuperviseurPresencesFormationsDeGroupe({
        idAnimateur: self.$route.query.idAnimateur,
        idFormation: self.$route.params.id,
      });

      //this.GetPresencesFormationsDeGroupeDuSuperviseur({userId: this.$route.query.idAnimateur,project:this.projetSelected})
    },
    deletePresenceFormationDeGroupe(membre) {
      const self = this;
      const delete_query = this.$firebase
        .firestore()
        .collection("presencesFormationsGroupes")
        .where("membres_id_membre", "==", membre.id)
        .where(
          "formations_groupes_id_formation_groupe",
          "==",
          self.$route.params.id
        );
      delete_query.get().then(function (querySnapshot) {
        querySnapshot.forEach(function (doc) {
          doc.ref.delete();
          console.log(
            " Présence Formation de groupe supprimé idmembre: ",
            membre
          );
          self.GetSuperviseurPresencesFormationsDeGroupe({
            idAnimateur: self.$route.query.idAnimateur,
            idFormation: self.$route.params.id,
          });

          // self.GetPresencesFormationsDeGroupeDuSuperviseur({userId: self.$route.query.idAnimateur,project:self.projetSelected})

          var idx = _.findIndex(self.MembresDuGroupeActifs, function (o) {
            return o.id == membre.id;
          });
          self.MembresDuGroupeActifs[idx].present = false;
        });
      });
    },
    getSexe(sexe) {
      if (sexe == "1") {
        return "Masculin";
      } else {
        return "Féminin";
      }
    },
    calculate_age(dob) {
      var diff_ms = Date.now() - dob.getTime();
      var age_dt = new Date(diff_ms);
      return Math.abs(age_dt.getUTCFullYear() - 1970);
    },
    ...mapActions({
      GetFormationsDeGroupe: "FormationsDeGroupe/GetFormationsDeGroupe",
      GetFormationsDuSuperviseur:
        "FormationsDeGroupe/GetFormationsDuSuperviseur",
      GetMembresDuGroupe: "Membres/GetMembresDuGroupe",
      GetSuperviseurPresencesFormationsDeGroupe:
        "PresencesFormationsDeGroupe/GetSuperviseurPresencesFormationsDeGroupe",
      GetPresencesFormationsDeGroupeDuSuperviseur:
        "PresencesFormationsDeGroupe/GetPresencesFormationsDeGroupeDuSuperviseur",
      addOneItem: "PresencesFormationsDeGroupe/addOneItem",
      UpdateMembreDansAutresCollections:
        "Membres/UpdateMembreDansAutresCollections",
      GetMembresDuGroupeInactifs: "Membres/GetMembresDuGroupeInactifs",
    }),
  },
  watch: {
    NombreMembresPresents: function (val) {
      let self = this;
      // console.log("NombreMembresPresents: ", val.length);
      // console.log("presence ID:", this.$route.params.id);
      var ref = this.$firebase
        .firestore()
        .collection("formationsDeGroupe")
        .doc(this.$route.params.id);
      return ref
        .update({
          presence: val.length,
          // nombreMembres: self.MembresDuGroupeActifs.length,
        })
        .then(() => {
          console.log("Nombre de membres présents successfully updated!");
        })
        .catch((error) => {
          // The document probably doesn't exist.
          console.error("Error updating document: ", error);
        });
    },
  },
  computed: {
    ...mapState({
      user: (state) => state.Auth.user,
      projetSelected: (state) => state.Auth.projetSelected,
      MembresDuGroupe: (state) => state.Membres.MembresDuGroupe,
      MembresDuGroupeActifs: (state) =>
        _.filter(state.Membres.MembresDuGroupe, { actif_dans_groupe: 1 }),
      SuperviseurNavigation: (state) => state.Navigation.SuperviseurNavigation,
      PresencesFormationsDeGroupeDeSuperviseur: (state) =>
        state.PresencesFormationsDeGroupe
          .PresencesFormationsDeGroupeDeSuperviseur,
    }),
    membresPresents: function () {
      /*    var MembresDuGroupe = [];
    _.forEach(this.MembresDuGroupeActifs, function (membre) {
        delete membre.present;
        MembresDuGroupe.push(membre);
      }); */
      var MembresDuGroupe = this.MembresDuGroupe;
      const idFormation = this.$route.params.id;
      const PresencesDelaFormation = _.filter(
        this.PresencesFormationsDeGroupeDeSuperviseur,
        { formations_groupes_id_formation_groupe: this.$route.params.id }
      );
      var idMembresPresents = [];
      _.forEach(PresencesDelaFormation, function (membrePresent) {
        idMembresPresents.push(membrePresent.membres_id_membre);
      });
      var listePresents = [];
      _.forEach(MembresDuGroupe, function (membre, key) {
        if (_.includes(idMembresPresents, membre.id)) {
          membre.present = true;
        }
        listePresents.push(membre);
      });
      return listePresents;
    },
    NombreMembresPresents: function () {
      var MembresDuGroupe = [];
      _.forEach(this.MembresDuGroupeActifs, function (membre) {
        delete membre.present;
        MembresDuGroupe.push(membre);
      });
      const PresencesDelaFormation = _.filter(
        this.PresencesFormationsDeGroupeDeSuperviseur,
        { formations_groupes_id_formation_groupe: this.$route.params.id }
      );
      var idMembresPresents = [];
      _.forEach(PresencesDelaFormation, function (membrePresent) {
        idMembresPresents.push(membrePresent.membres_id_membre);
      });
      return idMembresPresents;
    },
    listeMembresPresents: function () {
      var envoi = { nbFemme: 0, nbHomme: 0 };
      envoi.nbFemme = _.filter(this.PresencesFormationsDeGroupeDeSuperviseur, {
        formations_groupes_id_formation_groupe: this.$route.params.id,
        sexe: 0,
      }).length;
      envoi.nbHomme = _.filter(this.PresencesFormationsDeGroupeDeSuperviseur, {
        formations_groupes_id_formation_groupe: this.$route.params.id,
        sexe: 1,
      }).length;
      return envoi;
    },
  },
};
</script>

<style scoped>
.flex-table {
  display: grid;
  grid-template-columns: repeat(auto-fill, 25%);
  padding: 10px;
  border-bottom: 1px #ccc solid;
}
.inactif_dans_groupe {
  display: none;
}
</style>
